import React from 'react';
import Tracking from 'client/utils/tracking';

import UserTracker from './UserTracker';
import PageTracker from './PageTracker';

Tracking.setup();

const Tracker = () => {
  return (
    <>
      <PageTracker />
      <UserTracker />
    </>
  );
};

export default Tracker;
